<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="mini"
    :color="returnColor()"
    absolute
    class="custom-scrollbar"
    app
    floating
    dark
    dense
    permanent
  >
    <!-- expand-on-hover -->
    <div class="">
      <v-list nav dense>
        <v-list-item dense class="" link to="/home" title="Home">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="font-weight-bold">Home</v-list-item-title>
        </v-list-item>
        <v-list-group
          v-for="item in items"
          :key="item.title"
          v-show="item.is_view"
          active-class="border "
          color="white"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-icon :title="item.title">
              <img
                v-if="item.is_custom_icon"
                :src="require('@/assets/icons/' + item.icon)"
                class="white-image"
                :alt="item.title"
                contain
                :height="item.height"
              />
              <v-icon v-else>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="font-weight-bold"
                v-text="item.title"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            link
            v-for="child in item.items"
            :key="child.title"
            v-show="child.is_view"
            :to="child.path"
            hover-class="border-left"
            @click="getSubmenu(child.title, child.path)"
          >
            <v-list-item-content>
              <v-list-item-title
                class="font-weight-bold"
                v-text="child.title"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>
    <template v-slot:append>
      <v-list-item @click="mini = true" v-if="!mini" dense>
        <v-list-item-icon>
          <v-icon>mdi-chevron-triple-left</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-subtitle>Collapse Sidebar</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="mini = false" v-else dense>
        <v-list-item-icon>
          <v-icon>mdi-chevron-triple-right</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-subtitle class="font-weight-bold"
            >Collapse Sidebar</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
const pjson = require("../../../package.json");
// import EventBus from "@/helpers/GlobalFunctions";
export default {
  name: "SideNavigation",
  props: {
    isMenuMinimized: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      appVersion: pjson.version,
      drawer: true,

      items: [
        {
          title: "Accounts Detail",
          // icon: "mdi-treasure-chest",
          icon: "Accounting.svg",
          is_custom_icon: true,
          height: "21",
          items: [
            { title: "Statement of Account", path: "/statementReport" },
            { title: "Deals", path: "/Treasury/deals" },
            // { title: "Business Deals ", path: "/Treasury/dealsBu" },
            // { title: "Settlements ", path: "/Treasury/settlements" },
            { title: "Ledger Account Group", path: "/Treasury/LedgerAccount" },
            { title: "Deposit Channel", path: "/depositChannel" },
            { title: "Voucher Entry", path: "/Treasury/voucherEntry" },
            {
              title: "Voucher Not Approved",
              path: "/Treasury/voucherApproval",
            },
            { title: "Voucher Report", path: "/Treasury/voucherReport" },
            // { title: "Funding ", path: "/Treasury/funding" },
          ],
        },
        {
          title: "Partners",
          icon: "partners.svg",
          is_custom_icon: true,
          // icon: "mdi-bank-transfer",
          // is_custom_icon: false,
          items: [
            // { title: "Create Partner", path: "/createPartner" },
            { title: "Partner Summary", path: "/summary" },
            { title: "User Search", path: "/userSearch" },

            // {
            //   title: "Supportive Bank-x",
            //   path: "/supportiveBank",
            // },
            { title: "Payee Route", path: "/PayRouteStep" },
            { title: "Partner Route", path: "/partnerRoutestep" },

            {
              title: "Partner Utilities",
              path: "/partnerUtilities",
            },
            // {
            //   title: "Payout Partner Bank Summary-x",
            //   path: "/payoutPartner",
            // },

            // {
            //   title: "Manage Collection Point-x",
            //   path: "/manageCollectionpoint",
            // },
          ],
        },
        {
          title: "Exchange Rates",
          icon: "exchange-rate.svg",
          height: "21",
          is_custom_icon: true,
          items: [
            { title: "FX Cost Rate", path: "/fxCostRate" },
            { title: "FX Cost Rate Biz", path: "/fxCostRateBiz" },
            { title: "FX Rate Setup", path: "/fxRateSetup" },
            { title: "FX Selling Rate", path: "/fxExchangeRateSetup" },
            { title: "FX Selling Rate Biz", path: "/FXRateUpdateBiz" },
            { title: "FX Selling Rate History", path: "/FXRateHistory" },
            { title: "FX Cost Schedule", path: "/fxrateSchedule" },
            { title: "Dashboard Rates", path: "/Treasury/Rates" },
          ],
        },
        {
          title: "Service Charge",
          icon: "serviceCharge.svg",
          is_custom_icon: true,
          height: "21",
          items: [
            {
              title: "Service Charge Setup",
              path: "/serviceCharge",
            },
            {
              title: "Service Charge Setup Biz",
              path: "/ServiceChargeSetupBiz",
            },
          ],
        },
        {
          title: "Country",
          icon: "country.svg",
          is_custom_icon: true,
          items: [{ title: "Country Setup", path: "/Country" }],
        },
        {
          title: "Customers",
          icon: "mdi-account-group-outline",
          items: [
            { title: "Customer Details", path: "/compliance/CustomerList" },
            { title: "Customer Search", path: "/compliance/CustomerSearch" },
            { title: "Customer KYC", path: "/compliance/CustomerKYC" },
            { title: "Manage Customer", path: "/compliance/CustomerSummary" },
            { title: "Add Customer", path: "/addCustomer" },
            { title: "Push Customer", path: "/pushCustomers" },
          ],
        },
        {
          title: "Domestic Payments",
          icon: "mdi-home-switch",
          items: [
            { title: "Account Mapping", path: "/customerUpdate" },
            // { title: "Transaction", path: "/Transactionpage" },
            { title: "Pay In", path: "/payin" },
            { title: "Pay Out", path: "/payout" },
          ],
        },

        {
          title: "Transactions",
          // icon: "mdi-briefcase-arrow-left-right-outline",
          icon: "transactions.svg",
          height: "21",
          is_custom_icon: true,
          items: [
            { title: "Transaction", path: "/Transactionpage" },

            { title: "Hold Transactions", path: "/TransHoldpage" },
            { title: "Push Transactions", path: "/TransPush" },
            { title: "Manual Transaction Update", path: "/ManualTransaction" },
            { title: "Force Transaction Update", path: "/ForceTransaction" },
          ],
        },
        {
          title: "Compliance",
          icon: "mdi-shield-account",
          is_custom_icon: false,
          items: [
            // { title: "Add Compliance Rules", path: "/complianceRules" },
            // { title: "Add Compliance Rules New", path: "/complianceRulesNew" },
            { title: "Suspicious Hold List", path: "/suspiciousList" },
            { title: "Suspicious Customer", path: "/suspiciousCustomer" },
            { title: "Compliance Rules", path: "/getCompliancerule" },
            {
              title: "Compliance Limit",
              path: "/complianceLimts",
            },
            {
              title: "Individual Risk",
              path: "/complianceInd",
            },
            {
              title: "Business Risk",
              path: "/complianceBus",
            },
            {
              title: "Sanction List ",
              path: "/Blacklist/sanctionList",
            },

            {
              title: "Sanction Search",
              path: "/Blacklist/sanctionSearch",
            },
            {
              title: "Manual Sanction Entry",
              path: "/Blacklist/Manualcompliance",
            },
            {
              title: "Compilance Control",
              path: "/complianceSetup",
            },
          ],
        },
        {
          title: "User Management",
          // icon: "mdi-account-plus-outline",
          icon: "users.svg",
          is_custom_icon: true,
          items: [
            // { title: "Partner User", path: "/addPartener" },
            // { title: "List Of Partners", path: "/listOfPartners" },
            // { title: "Admin User", path: "/Adduser" },
            { title: "List Of Users", path: "/Listofuser" },
            { title: "Locked Users", path: "/locekdusers" },
            {
              title: "Manage Roles",
              path: "/RolesSummary",
            },
            // { title: "Security", path: "/security" },
          ],
        },
        {
          title: "Reports",
          // icon: "mdi-account-plus-outline",
          icon: "mdi-file",
          is_custom_icon: false,
          items: [
            { title: "Transaction Report", path: "/v2transactionreport" },
            { title: "RSP Report", path: "/rspreport" },
            { title: "RBA Report", path: "/rba-report" },
            {
              title: "Transaction Analysis Report",
              path: "/txn-analysis-report",
            },
          ],
        },
        // {
        //   title: "Roles",
        //   icon: "mdi-account-switch-outline",
        //   items: [
        //     // {
        //     //   title: "Add New Role",
        //     //   path: "/NewRole",
        //     // },
        //     {
        //       title: "Roles Summary",
        //       path: "/RolesSummary",
        //     },
        //   ],
        // },

        // {
        //   title: "Agent",
        //   icon: "mdi-account-tie",
        //   items: [{ title: "Send Transaction", path: "/CustomerList" }],
        // },

        {
          title: "Settings",
          icon: "settings.svg",
          is_custom_icon: true,
          items: [
            { title: "Master Data", path: "/MasterData" },
            { title: "Master Data Mapping", path: "/MasterDataMap" },
            { title: "Password Format", path: "/settings/PasswordFormat" },
            // { title: "Master Bank-x", path: "/settings/masterBank" },
            { title: "Payout Field Setup", path: "/Field-setup" },
            { title: "Master Bank / Branch Setup", path: "/MasterBankSummary" },
            {
              title: "Sanctions Bulk Upload",
              path: "/settings/sanctions-bulk-upload",
            },
            // { title: "", path: "/MasterBankSummary" },
            // { title: "", path: "/MasterBankSummary" },
            // { title: "", path: "/MasterBankSummary" },
            // {
            //   title: "Collection Limit-x",
            //   path: "/Collectionlimit",
            // },
            // {
            //   title: "Payout Limit-x",
            //   path: "/payoutLimit",
            // },
            {
              title: "Jobs",
              path: "/settings/cronejobs",
            },
            // {
            //   title: "Tax Configuration-x",
            //   path: "/settings/TaxConfiguratoion",
            // },
          ],
        },

        // {
        //   title: "Black List",
        //   icon: "Block.svg",
        //   is_custom_icon: true,
        //   items: [],
        // },

        {
          title: "Logs",
          icon: "Logs.svg",
          is_custom_icon: true,
          height: "21",
          // icon: "mdi-card-account-details-outline",
          // is_custom_icon: false,
          items: [
            { title: "Locked Customers", path: "/locekdcustomers" },

            { title: "Error", path: "/errorLogs" },
            { title: "Api", path: "/apiLog" },
            { title: "Integration", path: "/integrationLog" },
            { title: "Customer Audit", path: "/customerAduit" },
            { title: "Admin Audit", path: "/adminuserAduit" },
            { title: "Login User", path: "/loginUser" },
            { title: "Transaction Log", path: "/Transactionlog" },
            { title: "Transaction Locked", path: "/Transactionlocked" },
            { title: "Transaction Modified", path: "/Transactionmodified" },
            { title: "Transaction Audit", path: "/Transactionaudit" },
          ],
        },
        {
          title: "Developer Mode",
          icon: "mdi-application-brackets-outline",
          is_custom_icon: false,
          items: [
            {
              title: "modules-for-roles",
              icon: "mdi-gavel-outline",
              path: "/modules-for-roles",
            },
          ],
        },
      ],
      mini: true,
      isMobileBreakPoint: window.innerWidth < 720,
    };
  },
  created() {
    const data = this.updateItemsWithPermissions(
      this.items,
      JSON.parse(sessionStorage.getItem("__p_info")),
    );
    console.log("direct==>", data);
    let routeData = this.$route;
    //to call getsubmenu if user refresh the page
    if (routeData.path && routeData.path != "/home") {
      this.items.map((ele) => {
        ele.items.map((sub) => {
          if (sub.path === routeData.path) {
            this.getSubmenu(sub.title, sub.path);
          }
        });
      });
    }
  },
  watch: {
    mini(newVal) {
      this.$emit("minimizeMenu", newVal);
    },
    isMenuMinimized(newVal) {
      console.log(newVal);
      this.mini = newVal;
    },
  },
  methods: {
    updateItemsWithPermissions(items, permissionsInfo) {
      return items.map((item) => {
        if (permissionsInfo) {
          const matchingPermission = permissionsInfo[item.title];
          console.log(matchingPermission);
          if (matchingPermission) {
            const is_view = matchingPermission.some(
              (ele) => ele.is_view === "True",
            );
            is_view ? (item.is_view = true) : (item.is_view = false);
            if (item.items && item.items.length > 0) {
              item.items.forEach((ele) => {
                matchingPermission.forEach((sub_module) => {
                  if (
                    sub_module.sub_module_name === ele.title &&
                    sub_module.is_view === "True"
                  ) {
                    return (ele.is_view = true);
                  } else if (
                    sub_module.sub_module_name === ele.title &&
                    sub_module.is_view === "False"
                  ) {
                    return (ele.is_view = false);
                  }
                });
              });
            }
          }

          return item;
        } else {
          return item;
        }
      });
    },
    returnColor() {
      return `#${process.env.VUE_APP_COLOR}`;
    },
    //to emit selected tab to layout page
    getSubmenu(title, path) {
      console.log("title: ", title, "path :", path);
      this.$emit("slectedTab", { title: title, path: path, close: true });
    },

    minimizeMenu() {
      this.$emit("minimizeMenu", true);
      this.mini = !this.mini;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
::v-deep ::-webkit-scrollbar {
  width: 0;
  background: transparent;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px;
}
.v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}
.my-icon {
  padding: 0 !important;
  margin: 0 !important;
  /* font-size: 24px !important; */
}

.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 50px;
}
.v-application a {
  text-decoration: none !important;
}
.white-image {
  filter: brightness(0) invert(1) grayscale(1);
}
.font-icons {
  font-size: 24px !important;
}
// .active-col {
//   color: white;
// }
</style>
